import React from "react";
import "./App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Reserva from "./pages/Reserva/Reserva";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import Solicitudes from "./pages/Reserva/Solicitudes";
import Revisar from "./pages/Revisar/Revisar";
import MainLayout from "./componentes/MainLayout";
import Nuevo from "./pages/Reserva/Nuevo";
import ProtectedRoute from "./componentes/ProtectedRoute";
import ValidarReserva from "./pages/ValidarReserva/ValidarReserva";
import SolicitudesConstitución from "./pages/ValidarReserva/Solicitudes";
import Registro from "./pages/ValidarReserva/Registro";
import RevisarConstitucion from "./pages/RevisarConstitucion/RevisarConstitucion";
import Catastro from "./pages/Catastro/BandejaCatastro";
import ValidarDocumento from "./pages/Documento/ValidarDocumento";
import Page403 from "./pages/Error/Page403";

function App(props) {
  const basename = process.env.NODE_ENV === "production" ? "/fr-seps-sicca-web-public" : "/";

  return (
    <BrowserRouter
      basename={basename}
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <Routes>
        <Route element={<MainLayout />}>
          <Route path="/reserva" element={<Reserva />} />
          <Route path="/constitucion" element={<ValidarReserva />} />
          <Route path="/catastro" element={<Catastro />} />
          <Route path="/validar-comprobante" element={<ValidarDocumento />} />
          <Route path="/403" element={<Page403 />} />
          <Route element={<ProtectedRoute />}>
            <Route path="/solicitudes" element={<Solicitudes />} />
            <Route path="/solicitudes-constitucion" element={<SolicitudesConstitución />} />
            <Route path="/solicitudes/nuevo" element={<Nuevo />} />
            <Route path="/solicitudes-constitucion/nuevo" element={<Registro />} />
            <Route path="/solicitudes/revisar" element={<Revisar />} />
            <Route path="/solicitudes-constitucion/revisar" element={<RevisarConstitucion />} />
          </Route>
        </Route>

        <Route path="*" element={<Navigate to="/reserva" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
